import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookExecutionStateService = ( createDecorator('INotebookExecutionStateService'));
export { INotebookExecutionStateService };
